import client from "./client";
import * as types from "./types";

/**
 * Recupera el listado de destinos del vendedor.
 */
export async function find(): Promise<types.Destination[]> {
  const response = await client.get("/destinations");

  return response.data;
}
